<template>
  <div class="customized-sep-place-holder">
    <div
      class="sep-place-holder"
      :style="`height: ${setData.blankSpace}px; backgroundColor: ${
        setData.backgroundColor
      }; opacity: ${setData.backgroundShow ? 1 : 0}`"
    >
      <div
        v-if="setData.showType == 'delimiter'"
        class="border"
        :style="`borderTop: 0.5px ${setData.lineStyle} ${setData.lineColor};`"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SepPlaceHolder',
  components: {},
  props: {
    setData: {
      type: Object,
      default: () => {
        return {
          showType: 'blank', // 展示方式 blank delimiter
          lineStyle: 'dashed', // 线样式 solid dashed dotted
          lineColor: '#000000', // 线颜色
          blankSpace: 50, // 空白间距
          backgroundColor: '#fff', // 背景颜色
          backgroundShow: true, // 背景展示 true false
        }
      },
    },
  },
  data() {
    return {
      blankClassName: `blankSpace-${this.setData.showType}`,
      delimiterClassName: `showType-${this.setData.showType}`,
    }
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.customized-sep-place-holder {
  .sep-place-holder {
    position: relative;
    .border {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 355px;
      height: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/SepPlaceHolder.vue